import { useEffect, useRef, useState } from "react";
import { useAccount } from "./useAccount";
import { Avviso, Bottone, Campo, PaginaAccount, Scheda } from "./ui";
import { C } from "../theme/tokens";
import { traccia } from "../consenso/tracciamento";

/**
 * Pagina raggiunta dai link delle email di conferma: quella della
 * registrazione e, con `tipo=email`, quella del cambio d'indirizzo. Il token
 * viene speso con una POST fatta da qui, non dal link stesso: gli scanner di
 * posta aprono i link, e con una GET avrebbero consumato il token al posto
 * dell'utente.
 */
export default function VerificaPage({ onNavigate, token, tipo }) {
  const { imposta, api } = useAccount();
  const cambioEmail = tipo === "email";
  const [stato, setStato] = useState(token ? "in_corso" : "senza_token");
  const [errore, setErrore] = useState(null);
  const [email, setEmail] = useState("");
  const [reinviato, setReinviato] = useState(null);
  const avviato = useRef(false);

  useEffect(() => {
    if (!token || avviato.current) return;
    avviato.current = true;
    (async () => {
      try {
        if (cambioEmail) {
          imposta(await api.confermaEmail(token));
          onNavigate("account", { verifica: "email" });
          return;
        }
        const profilo = await api.verifica(token);
        imposta(profilo);
        traccia.registrazioneConfermata();
        onNavigate("account", { verifica: "ok" });
      } catch (err) {
        setErrore(err.message);
        setStato("fallita");
      }
    })();
  }, [token, cambioEmail, api, imposta, onNavigate]);

  const reinvia = async (e) => {
    e.preventDefault();
    try {
      const r = await api.reinviaVerifica(email);
      setReinviato(r.messaggio || "Email inviata.");
    } catch (err) {
      setErrore(err.message);
    }
  };

  return (
    <PaginaAccount titolo={cambioEmail ? "Conferma del nuovo indirizzo" : "Conferma dell'indirizzo"} onBack={() => onNavigate("landing")}>
      <Scheda>
        {stato === "in_corso" && <p style={{ margin: 0, fontSize: 14, color: C.textBody }}>Conferma in corso...</p>}
        {stato !== "in_corso" && cambioEmail && (
          <>
            <Avviso tipo="attenzione">
              {stato === "senza_token" ? "Manca il codice di conferma: apri il link che trovi nell'email." : errore}
            </Avviso>
            <p style={{ fontSize: 13, color: C.textNum, lineHeight: 1.5, margin: "0 0 14px" }}>
              Il link vale 24 ore e si usa una volta sola. Se e&apos; scaduto, chiedi di nuovo il cambio d&apos;indirizzo dall&apos;area clienti: fino ad allora resta valido l&apos;indirizzo di prima.
            </p>
            <Bottone variante="secondario" onClick={() => onNavigate("account")}>Vai all&apos;area clienti</Bottone>
          </>
        )}
        {stato !== "in_corso" && !cambioEmail && (
          <>
            <Avviso tipo="attenzione">
              {stato === "senza_token" ? "Manca il codice di conferma: apri il link che trovi nell'email." : errore}
            </Avviso>
            <p style={{ fontSize: 13, color: C.textNum, lineHeight: 1.5, margin: "0 0 14px" }}>
              I link valgono 24 ore e si usano una volta sola. Se e&apos; scaduto, inserisci l&apos;indirizzo e te ne mandiamo uno nuovo.
            </p>
            <form onSubmit={reinvia}>
              <Campo etichetta="Email" tipo="email" valore={email} onChange={setEmail} autoComplete="email" />
              {reinviato && <Avviso tipo="ok">{reinviato}</Avviso>}
              <Bottone tipo="submit" variante="secondario">Reinvia l&apos;email di conferma</Bottone>
            </form>
          </>
        )}
      </Scheda>
    </PaginaAccount>
  );
}
